
import React from 'react';
import './ContactUs.css';

const ContactUs = () => {
    return (
        <div className="contact-us">
            <header className="contact-header" style={{ 
                backgroundImage: "url('/assets/contact.jpg')", 
                backgroundSize: 'cover', 
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}>
                <h1>Contact Us</h1>
                <p>We would love to hear from you. Get in touch with us!</p>
            </header>
            
            <section className="contact-info">
                <div className="info-card">
                    <h3>Email</h3>
                    <p>contact@ensuresap.com</p>
                </div>
                <div className="info-card">
                    <h3>Phone</h3>
                    <p>+1 (973) 370-3873</p>
                </div>
                <div className="info-card">
                    <h3>Address</h3>
                    <p>FIVE GREENTREE CENTRE</p>
<p>525 ROUTE 73 NORTH STE 104</p>
          <p>MARLTON, NJ 08053</p>
                </div>
            </section>
            
            <section className="inquiry-form">
                <h2>Send Us a Message</h2>
                <form>
                    <div className="form-group">
                        <label>Name</label>
                        <input type="text" placeholder="Enter your name" required />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" placeholder="Enter your email" required />
                    </div>
                    <div className="form-group">
                        <label>Message</label>
                        <textarea placeholder="Enter your message" rows="4" required></textarea>
                    </div>
                    <button type="submit" className="btn-primary">Send Message</button>
                </form>
            </section>
            
           
        </div>
    );
};

export default ContactUs;
